import PropTypes from "prop-types"
import { CircularProgress } from "@mui/material"

export function GraphLoadingState({ message = "Loading data..." }) {
  return (
    <div className="graph-content">
      <div className="graph-loading">
        <CircularProgress size={40} />
        <p>{message}</p>
      </div>
    </div>
  )
}

GraphLoadingState.propTypes = {
  message: PropTypes.string,
}

export function GraphEmptyState({ message = "No data available." }) {
  return (
    <div className="graph-content">
      <div className="graph-empty">
        <p>{message}</p>
      </div>
    </div>
  )
}

GraphEmptyState.propTypes = {
  message: PropTypes.string,
}
